"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    getShowFieldValues: function (datas, displayField, pkField) {
        // {"refname":"人员5-自定义;人员8","refpk":"5e3a85ec-5e14-4734-8b3a-1e6168426c89;a9f4c869-ca0b-4d12-847e-00eca08bfef6"}
        var fns = [];
        var pks = [];
        (datas || []).forEach(function (data) {
            fns.push(data[displayField]);
            pks.push(data[pkField]);
        });
        var result = "{\"refname\": \"".concat(fns.join(";"), "\", \"refpk\": \"").concat(pks.join(";"), "\"}");
        if (window.isAipDebug) {
            console.log(result);
        }
        return result;
    },
    isEmptyParam: function (params) {
        var kys = [];
        for (var k in params) {
            kys.push(k);
        }
        return kys.length === 0;
    },
    getProjectId: function () {
        return localStorage.getItem("projectid");
    },
    setProjectId: function (projectId) {
        localStorage.setItem("projectid", projectId);
    },
    evil: function (fn) {
        var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
        return new Fn("return " + fn)();
    },
    cloneObject: function (obj) {
        // 注意：该方法只能对plain object有效
        return JSON.parse(JSON.stringify(obj));
    },
};
